import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';
import { Mail, ArrowLeft } from 'lucide-react';
import { useTranslation } from '../i18n';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ForgotPassword = ({ lang = 'en' }) => {
  const { t } = useTranslation(lang);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/password-reset/forgot`, { email });
      setSent(true);
      toast.success(t('forgotPassword.resetSuccess'));
    } catch (error) {
      console.error('Error:', error);
      toast.success(t('forgotPassword.linkSent'));
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4" style={{ background: 'var(--bg-secondary)' }}>
      <div className="max-w-md w-full space-y-8">
        <div className="rounded-lg shadow-xl p-8" style={{ background: 'var(--bg-primary)' }}>
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-4" style={{ background: 'var(--accent)' }}>
              <Mail className="w-8 h-8 text-white" />
            </div>
            <h2 className="text-3xl font-bold" style={{ fontFamily: 'Playfair Display', color: 'var(--text-primary)' }}>
              {t('forgotPassword.title')}
            </h2>
            <p className="mt-2" style={{ color: 'var(--text-secondary)' }}>
              {t('forgotPassword.subtitle')}
            </p>
          </div>

          {!sent ? (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <Input
                  type="email"
                  placeholder={t('forgotPassword.emailPlaceholder')}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full"
                />
              </div>

              <Button type="submit" className="w-full" disabled={loading}>
                {loading ? t('forgotPassword.sending') : t('forgotPassword.sendResetLink')}
              </Button>

              <div className="text-center">
                <Link to="/login" className="inline-flex items-center gap-2 text-sm" style={{ color: 'var(--accent)' }}>
                  <ArrowLeft className="w-4 h-4" />
                  {t('forgotPassword.backToLogin')}
                </Link>
              </div>
            </form>
          ) : (
            <div className="text-center space-y-4">
              <div className="p-4 rounded" style={{ background: 'var(--bg-secondary)' }}>
                <p style={{ color: 'var(--text-primary)' }}>
                  ✅ {t('forgotPassword.linkSent')}
                </p>
                <p className="mt-2 text-sm" style={{ color: 'var(--text-secondary)' }}>
                  {t('forgotPassword.checkEmail')}
                </p>
              </div>

              <Link to="/login">
                <Button variant="outline" className="w-full">
                  {t('forgotPassword.backToLogin')}
                </Button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
